<template>
    <v-dialog v-model="show" scrollable>
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card :disabled="loading" :loading="loading">
            <v-card-title>
              Create Order {{nanoid}}
              <v-spacer></v-spacer>
              <v-btn @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
                <v-card-text class="pa-0">
                  <v-row justify="space-around" no-gutters>
                    <v-col cols="4">
                      <SampleForm ref="sample_form" :manifest="manifest" :manifest_samples="manifest_samples" :edit_sample="edit_sample" @add_sample="addSample($event)" @done_editing="finishedEditing"></SampleForm>
                    </v-col>
                    <v-col cols="7">
                      <CreateOrderTable @save="save" @remove_sample="removeSample($event)" @edit_sample="editSample($event)" :samples="samples"></CreateOrderTable>
                    </v-col>
                  </v-row>
                </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import CreateOrderTable from "./CreateOrderTable";
    import SampleForm from "./SampleForm";
    import {nanoid} from 'nanoid'
    export default {
        name: "CreateOrder",
        components:{
            CreateOrderTable,
            SampleForm,
        },
        data: () => ({
          show: false,
            loading: false,
            edit_sample: null,
            samples: [],
            manifest_samples: null,
            nanoid: nanoid(),
        }),
        props:{
          manifest:{
            required: false,
          }
        },
        mounted(){
            this.loadData();
        },
        watch:{
          show(v){
            if(v && !this.manifest_samples && !this.loading){
              this.loadData();
            }
          }
        },
        computed:{
            sampleTypes(){
                return this.$store.$db().model('sampleCertTypes').all();
            }
        },
        methods:{
            async loadData(){
              this.loading = true;
                if(this.manifest){
                  this.samples = [];
                  if(this.$refs.sample_form) {
                    this.$refs.sample_form.currentManifestSample = 0;
                    this.edit_sample = null;
                  }
                  await this.loadManifest()
                }
                this.loading = false;
            },
            async loadManifest(){
              let manifest = this.manifest;
              let customer = await this.$store.$db().model('licenses').api().fetch({
                where:{
                  key: "license",
                  value: manifest.global_id.split('.')[0].substr(2)
                }
              })
              if(customer.response.data.length > 0){
                customer = customer.response.data[0].customer_id;
              }else{
                customer = null;
              }
              let sample = {
                customer_id: customer ? customer : null,
                order_id: null,
                customer_name_id: null,
                is_editing: false,
                manifest_id: manifest.global_id,
                unit_uuid: null,
                created_by: this.$store.getters.id,
                updated_by: null,
              }
              this.manifest_samples = manifest.inventory_transfer_items.map(item => {
                let sampleType = this.sampleTypes.find(type => {
                  let types = type.name.toLowerCase().split(" ");
                  return types.some(splitType => item.intermediate_type.includes(splitType));
                })
                return {
                  ...sample,
                  sample_cert_type: sampleType ? sampleType : null,
                  sample_cert_type_uuid: sampleType ? sampleType.uuid : null,
                  name: item.strain_name,
                  sample_type_uuid: null,
                  legal_type: item.intermediate_type,
                  qa: item.global_received_inventory_id,
                  lot: item.global_inventory_id,
                  is_rnd: false,
                  harvest_date: null,
                  serving_weight: null,
                  manifest_item: item,
                  notes: [],
                }
              })
              if(this.$refs.sample_form && !this.$refs.sample_form.manifestSet){ this.$refs.sample_form.manifestSet = true;}
            },
            removeSample(index){
                this.samples.splice(index, 1)
            },
            addSample(sample){
                sample.id = null;
                sample.weight = 0;
                sample.order_id = this.nanoid
                this.samples.push(sample);
            },
            editSample(sample){
                this.samples.filter(sample => sample.is_editing).forEach(sample => sample.is_editing = false);
                sample.is_editing = true;
                this.edit_sample = sample;
            },
            finishedEditing(){
                this.edit_sample.is_editing = false;
                this.edit_sample = null;
            },
            async save(){
              this.loading = true;
              try{
                let samples = await this.$store.$db().model('samples').api().save({
                  collection: this.samples
                })
                let submitSamples = [...this.samples];
                for(let i = 0; i < submitSamples.length; i+=1){
                  const uuid = samples.response.data[i].uuid;
                  submitSamples[i].uuid = uuid;
                  submitSamples[i].notes = submitSamples[i].notes.map(note => {
                    return {
                      ...note,
                      sample_uuid: uuid,
                      created_by: this.$store.getters.id,
                      updated_by: this.$store.getters.id,
                    }
                  })
                  submitSamples[i].tests = submitSamples[i].tests.map(test => {
                    return {
                      ...test,
                      sample_uuid: uuid
                    }
                  })
                }
                for(let i in submitSamples){
                  await this.$store.$db().model('sampleTests').api().save({
                    collection:submitSamples[i].tests
                  })
                  await this.$store.$db().model('sampleNotes').api().save({
                    collection:submitSamples[i].notes
                  })
                }
                this.$store.dispatch("showSuccess", "Saved order")
              }catch(e){
                this.$store.dispatch("showError", "Failed to save order")
              }finally{
                this.loading = false;
              }
              this.nanoid = nanoid();
              this.samples = []
            }
        }
    }
</script>

<style scoped>

</style>
